module.exports = __webpack_public_path__ + "img/ic_my_notification_white.00bb72d5.svg";